import { resetMainView } from 'actions/mainView'
import { reset as resetRecording } from 'reducers/recording'
import { updateSlider } from 'actions/timeline'

export const resetEditorBeforeProjectActivated = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  dispatch(resetMainView())
  dispatch(resetRecording())
  dispatch(updateSlider(0))
}
